import { BankStatementRemarksColumnName } from "../App";
function getOutstandingBankstatement(bankStatements: any[]) {
  const outstandingBankStatements = bankStatements.filter((statement) => {
    const bankDepositRemarks = statement[BankStatementRemarksColumnName];
    const alreadyMatched = statement.alreadyMatched;
    const isByCash = bankDepositRemarks.indexOf("BY CASH") > -1;
    return !(alreadyMatched || isByCash);
  });
  return outstandingBankStatements;
}

export { getOutstandingBankstatement };
